function ImageBox({
  imagesArray,
  currentPage,
  imageProperty,
}) {
  return (
    <>
    {imagesArray && <img
        src={imagesArray[currentPage - 1]}
        alt="PDF LOADING"
        style={{userSelect: 'none', width: imageProperty.width, transform: `rotate(${imageProperty.angle}deg)` }}
        />}
    </>
  )
}

export default ImageBox